/**
 * Représentations d'un participant : la ligne de liste et l'avatar.
 * La minimisation est déjà appliquée par l'API — ces composants affichent ce
 * qu'ils reçoivent, ils ne décident jamais de ce qui est montrable.
 */
import { Link } from 'react-router-dom';
import { Etoile } from './Etoile.tsx';

export type LigneParticipant = {
  participant_id: string;
  prenom: string | null;
  nom: string | null;
  entreprise: string | null;
  fonction: string | null;
  secteur: string | null;
  present?: boolean;
  premium?: boolean;
  influence?: number | null;
  c_est_moi?: boolean;
};

export function nomAffiche(p: { prenom: string | null; nom: string | null; fonction?: string | null }): string {
  const nom = [p.prenom, p.nom].filter(Boolean).join(' ');
  return nom || p.fonction || 'Participant';
}

export function initiales(p: { prenom: string | null; nom: string | null }): string {
  const i = `${p.prenom?.[0] ?? ''}${p.nom?.[0] ?? ''}`.toUpperCase();
  return i || '•';
}

/** Teinte d'avatar stable par identifiant : reconnaissable de liste en liste. */
function teinte(id: string): number {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) % 360;
  return h;
}

export function Avatar({ p }: { p: LigneParticipant }) {
  return (
    <span
      className="avatar"
      style={{ background: `oklch(0.85 0.08 ${teinte(p.participant_id)})`, color: '#1D2438' }}
      aria-hidden="true"
    >
      {initiales(p)}
    </span>
  );
}

export function LigneRepertoire({ p }: { p: LigneParticipant }) {
  return (
    <li>
      <Link to={`/participants/${p.participant_id}`} className="ligne-participant">
        <span className="ligne-participant__avatar">
          <Avatar p={p} />
          {p.present && <span className="pastille-presence" title="Sur place" />}
        </span>
        <span className="ligne-participant__texte">
          <span className="ligne-participant__nom">
            {nomAffiche(p)} <Etoile premium={p.premium} texte={false} />
            {p.c_est_moi && <span className="ligne-participant__moi">vous</span>}
          </span>
          <span className="ligne-participant__detail">
            {[p.fonction, p.entreprise].filter(Boolean).join(' · ')}
          </span>
        </span>
        {p.secteur && <span className="etiquette ligne-participant__secteur">{p.secteur}</span>}
      </Link>
    </li>
  );
}
